import { ActionHistorySectionProps } from "./action-history-section.types";
import styles from "./action-history-section.module.scss";
// import cl from 'classnames'
import { SectionContainer } from "@touche-lts/panel-ui/dist/components/shared/section-container";
import { H2 } from "@touche-lts/panel-ui/dist/components/shared/h2";
import {
  NoneLabel,
  PaginationButtons,
  TableBodyContainer,
  TableBodyLine,
  TableBodyLineProps,
  TableContainer,
  TableHeader,
} from "@touche-lts/panel-ui/dist";
import { observer } from "mobx-react-lite";
import { useRootStore } from "mobx-stores/store-provider";
import { useEffect } from "react";
import { ActionHistoryDTO } from "models";
import {
  ActionHistoryTableSortProps,
  ActionHistoryTableStatus,
} from "mobx-stores/utils/action-history-table-base/action-history-table-base.types";
import { toJS } from "mobx";
import { actionHistoryTableCellWidth } from "pages/acton-history/action-history-table/action-history.utils";
import cl from 'classnames'
import { useGetScrollWidth } from "hooks/custom-hooks";

const ActionHistorySectionComponent = (props: ActionHistorySectionProps) => {
  const { ...sectionContainerProps } = props;
  const {
    actionHistoryStore: {
      isColumnMarked,
      getSortDirection,
      handleSortDirectionChange,
      searchProps,
      onSearchPropsChange,
      searchResults,
      paginationInfo,
      onPageSelect,
      triggerSearchForUser,
      setUserId,
      statusTableHeader,
    },
    userProfilePageStore: { user },
  } = useRootStore();

  useEffect(() => {
    setUserId(user?.id);
    triggerSearchForUser({ id: user?.id, resetPageNumber: true });

    return () => {
      setUserId(null);
    };
  }, [user?.id]);

  const {scrollX, handleScroll} = useGetScrollWidth()

  const extraSpacing = 363
  const getBodyLineCells = (
      actionHistory: ActionHistoryDTO
    ): TableBodyLineProps["cells"] => {
      const cells: any = [
        {
          // widthPercentage: 79,
          widthPx : actionHistoryTableCellWidth.TIME,
          children: <>{new Date(actionHistory?.time).toLocaleString()}</>,
          isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.TIME),
        },
        {
          // widthPercentage: 81,
          widthPx : actionHistoryTableCellWidth.ACTION_TYPE,
          children: <>{actionHistory?.actionType}</>,
          isColumnMarked: isColumnMarked(
            ActionHistoryTableSortProps.ACTION_TYPE
          ),
        },
        {
          // widthPercentage: 82,
          widthPx : actionHistoryTableCellWidth.ENTITY_TITLE,
          children: <>{actionHistory?.entityTitle}</>,
          isColumnMarked: isColumnMarked(
            ActionHistoryTableSortProps.ENTITY_TITLE
          ),
        },
        {
          // widthPercentage: 78,
          widthPx : actionHistoryTableCellWidth.CHANGES + extraSpacing,
          children: (
            <>
              {actionHistory?.changes.map((changes) => {
                return (
                  <span className={styles.badgeChanges}>
                    {changes.changeType}
                  </span>
                );
              })}
            </>
          ),
          isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.CHANGES),
        },
      ];

      return cells;
    },
    tableColumns: any = [
      {
        label: "PERIOD",
        isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.TIME),
        sortDirection: getSortDirection(ActionHistoryTableSortProps.TIME),
        setSortDirection: handleSortDirectionChange(
          ActionHistoryTableSortProps.TIME
        ),
        periodFilterProps: {
          period: searchProps.orderDate,
          setPeriod: (orderDate) => onSearchPropsChange({ orderDate }),
          className: styles.customFilterComponent,
        },
        widthPx : actionHistoryTableCellWidth.TIME,
      },
      {
        label: "ACTION TYPE",
        isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.ACTION_TYPE),
        sortDirection: getSortDirection(
          ActionHistoryTableSortProps.ACTION_TYPE
        ),
        setSortDirection: handleSortDirectionChange(
          ActionHistoryTableSortProps.ACTION_TYPE
        ),
        selectProps: {
          noneLabel: "All",
          options: statusTableHeader,
          value: searchProps.actionType,
          onChange: (actionType: ActionHistoryTableStatus) =>
            onSearchPropsChange({ actionType }),
        },
        widthPx : actionHistoryTableCellWidth.ACTION_TYPE,
      },
      {
        label: "ENTITY TYPE",
        // widthPx: productsTableWidths.sku,
        isColumnMarked: isColumnMarked(
          ActionHistoryTableSortProps.ENTITY_TITLE
        ),
        sortDirection: getSortDirection(
          ActionHistoryTableSortProps.ENTITY_TITLE
        ),
        setSortDirection: handleSortDirectionChange(
          ActionHistoryTableSortProps.ENTITY_TITLE
        ),
        inputProps: {
          placeholder: "Search...",
          value: searchProps.entityTitle,
          onChange: (entityTitle) => onSearchPropsChange({ entityTitle }),
        },
        widthPx : actionHistoryTableCellWidth.ENTITY_TITLE,
      },
      {
        label: "CHANGES",
        isColumnMarked: isColumnMarked(ActionHistoryTableSortProps.CHANGES),
        sortDirection: getSortDirection(ActionHistoryTableSortProps.CHANGES),
        setSortDirection: handleSortDirectionChange(
          ActionHistoryTableSortProps.CHANGES
        ),
        inputProps: {
          placeholder: "Search...",
          value: searchProps.changes,
          onChange: (changes) => onSearchPropsChange({ changes }),
        },
        widthPx : actionHistoryTableCellWidth.CHANGES + extraSpacing,
      },
    ];

  return (
    <>
      <H2 className={styles.margin}>Action history</H2>
      <TableContainer className={cl(styles.position, styles.thinScroll)} style={{overflowX : 'auto'}} onScroll={handleScroll}>
        <TableHeader tableColumns={tableColumns} />
        <TableBodyContainer className={styles.tableBodyContainer}>
          {searchResults.map((actionHistory: ActionHistoryDTO) => {
            return (
              <TableBodyLine
                key={actionHistory.id}
                cells={getBodyLineCells(actionHistory)}
              />
            );
          })}

          {searchResults.length === 0 && (
            <NoneLabel
              style={{ textAlign: "center" }}
              label="No history yet."
            />
          )}
        </TableBodyContainer>
        <PaginationButtons
          alwaysShow
          {...paginationInfo}
          onPageSelect={onPageSelect}
          style={{width : scrollX === '100%' ? "100%" : "168%" }}
        />
      </TableContainer>
    </>
  );
};

const ActionHistorySection = observer(ActionHistorySectionComponent);
export { ActionHistorySection };
